module.exports = __webpack_public_path__ + "img/farzana-christopher-147.4dc2a39e.jpg";